import { render, staticRenderFns } from "./view-itinerary.vue?vue&type=template&id=2c4c8488&"
import script from "./view-itinerary.vue?vue&type=script&lang=js&"
export * from "./view-itinerary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports